import { Box, CircularProgress, IconButton, Typography } from '@mui/material';
import React from 'react';
import CustomButton from '../CustomButton/CustomButton';
import { CloseIcon } from '../Icons';

function RemoveItems({ setOpenModal, handleConfirmButton, supplierName, totalItems, btnLoading }) {
	return (
		<Box sx={{ width: '306px' }}>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					flexDirection: 'column',
					p: '24px 16px',
				}}
			>
				<img src="/remove-bin.svg" width={150} height={142} />
				<Typography variant="body2" sx={{ lineHeight: '24px', textAlign: 'center' }}>
					Deleting {totalItems} items from the order book for {supplierName}. Are you sure?
				</Typography>
			</Box>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					borderTop: '1.5px solid #F1F1F1',
					p: '16px',
				}}
			>
				<CustomButton
					title="Cancel"
					heightVariant="medium"
					color="secondary"
					handleClick={() => setOpenModal(false)}
					styles={{ width: '100%', mr: '8px' }}
				/>
				<CustomButton
					title={
						btnLoading ? (
							<CircularProgress size={16} style={{ color: 'var(--default-text-color)' }} />
						) : (
							'Confirm'
						)
					}
					heightVariant="medium"
					color="primary"
					handleClick={() => handleConfirmButton()}
					styles={{ width: '100%' }}
					disabled={btnLoading}
				/>
			</Box>
		</Box>
	);
}

export default RemoveItems;
